import {createFileRoute} from '@tanstack/react-router';
import {GuideCreatePage} from '@/features/guides';

export const Route = createFileRoute('/_app/guides/create')({
  validateSearch: (search: {new?: boolean; discountId?: string}) => {
    return search;
  },
  beforeLoad: () => ({
    getTitle: () => {
      return 'Новая инструкция';
    },
  }),
  component: () => <GuideCreatePage />,
});
